import { RotateCcw } from "lucide-react";

export const AIControls = ({ consent, setConsent, onReplay }) => (
  <div className="mt-8 space-y-3">
    <button
      type="button"
      role="switch"
      aria-checked={consent}
      onClick={() => setConsent((c) => !c)}
      data-testid="ai-consent-toggle"
      className="glass glass-light flex w-full max-w-[320px] items-center justify-between gap-4 rounded-2xl px-4 py-3 text-left"
    >
      <span>
        <span className="block text-[14px] font-semibold text-[#08090D]">Shashin's consent</span>
        <span className="block text-[12px] text-[#777B8D]">Switch it off to see what happens</span>
      </span>
      <span className="flex items-center gap-2">
        <span className="text-[13px] font-semibold text-[#08090D]" data-testid="ai-consent-state">{consent ? "On" : "Off"}</span>
        <span className={`ui-switch ${consent ? "is-on" : ""}`} aria-hidden><span /></span>
      </span>
    </button>
    <div className="flex items-center gap-3">
      <button type="button" onClick={onReplay} data-testid="ai-replay-button" className="btn-glass glass glass-light h-11 gap-2 px-5 text-[14px]">
        <RotateCcw size={15} aria-hidden /> Replay
      </button>
      <span className="text-[11px] text-[#666a7d]">Sample content — fictional demo</span>
    </div>
  </div>
);
